<div id="contact" class="contact-area bg-F7F5F4">
  <div class="container">
    <div class="section-title">
      <h2><span>Contáctanos</span></h2>
    </div>
    <div class="row">
      <div class="col-lg-8 col-12">
        <div class="contact-form">
          <form #contactForm="ngForm" (ngSubmit)="submit()">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group mb-3">
                  <label>Nombre</label>
                  <input required minlength="3" maxlength="50" ngModel name="name" type="text" #name="ngModel" class="form-control" id="name" placeholder="Escribe tu nombre completo">
                  @if (name.touched && name.invalid) {
                    <div class="field-error">
                      @if (name.errors?.required) {
                        <span>Ingresa tu nombre.</span>
                      }
                      @if (name.errors?.minlength) {
                        <span>El nombre debe tener al menos 3 caracteres.</span>
                      }
                      @if (name.errors?.maxlength) {
                        <span>El nombre no puede superar los 50 caracteres.</span>
                      }
                    </div>
                  }
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-3">
                  <label>Correo</label>
                  <input required email ngModel name="email" type="email" #email="ngModel" class="form-control" id="email" placeholder="nombre@correo.com">
                  @if (email.touched && email.invalid) {
                    <div class="field-error">
                      @if (email.errors?.required) {
                        <span>Ingresa tu correo electrónico.</span>
                      }
                      @if (email.errors?.email) {
                        <span>Escribe un correo electrónico válido.</span>
                      }
                    </div>
                  }
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-3">
                  <label>Indicativo</label>
                  <input required pattern="^[+0-9() -]{1,8}$" ngModel name="subject" type="text" #subject="ngModel" class="form-control" id="subject" placeholder="Ej. +57">
                  @if (subject.touched && subject.invalid) {
                    <div class="field-error">
                      @if (subject.errors?.required) {
                        <span>Ingresa el indicativo de tu país o ciudad.</span>
                      }
                      @if (subject.errors?.pattern) {
                        <span>Usa solamente números y el símbolo +.</span>
                      }
                    </div>
                  }
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-3">
                  <label>Teléfono</label>
                  <input required pattern="^[0-9() +\-]{7,20}$" ngModel name="number" type="tel" #number="ngModel" class="form-control" id="number" placeholder="Ej. 300 123 4567">
                  @if (number.touched && number.invalid) {
                    <div class="field-error">
                      @if (number.errors?.required) {
                        <span>Ingresa un número de teléfono.</span>
                      }
                      @if (number.errors?.pattern) {
                        <span>Escribe un teléfono válido de 7 a 20 caracteres.</span>
                      }
                    </div>
                  }
                </div>
              </div>
              <div class="col-lg-12 col-md-12">
                <div class="form-group mb-3">
                  <label>Mensaje</label>
                  <textarea required minlength="10" ngModel #message="ngModel" name="message" id="message" cols="30" rows="4" class="form-control" placeholder="Cuéntanos cómo podemos ayudarte"></textarea>
                  @if (message.touched && message.invalid) {
                    <div class="field-error">
                      @if (message.errors?.required) {
                        <span>Escribe un mensaje.</span>
                      }
                      @if (message.errors?.minlength) {
                        <span>El mensaje debe tener al menos 10 caracteres.</span>
                      }
                    </div>
                  }
                </div>
              </div>
              <div class="col-lg-12 col-md-12">
                <button type="submit" class="btn btn-primary" [class.disabled]="!contactForm.valid">
                  <i class="fas fa-paper-plane" aria-hidden="true"></i>
                  Enviar mensaje
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="col-lg-4 col-12">
        <div class="contact-info">
          <ul>
            <li><i class="fas fa-map-marker-alt"></i> <span>Ubicación</span>Km. 5 vía Puerto Colombia</li>
            <li><i class="far fa-solid fa-envelope"></i> <a href="mailto:cidhum@uninorte.edu.co"><span>Email</span>cidhum&#64;uninorte.edu.co</a></li>
            <li><i class="fas fa-phone-alt"></i> <a href="tel:+576013509509"><span>Teléfono</span>(601)3509509 Ext 4415</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
